import { $CombinedState } from "redux";
import { MathUtils } from "../../utils";

export function mappingGemsProductDetailSelection(params) {
  return {
    spuId: "$.obj.id",
    headingType: { fields: { phrase: { value: "h2" } } },
    headingBody: {
      value: `<span class="type-h1">${params.obj.productDescribe}</span>`
    },
    productName: params.obj.productDescribe,
    testFn: item => {
      return item.spuId;
    },
    variants: [
      "$.obj.skuAttributeList.",
      {
        label: "$.lable",
        defaultLanguageLabel: "$.defaultLanguageLabel",
        type: "image", //Override
        options: [
          "$.spuSkuAttibuteValueList.",
          {
            label: "$.value",
            value: "$.value",
            image: {
              src: "$.path",
              alt: ""
            }
          }
        ]
      }
    ]
  };
}

export function mappingSitecoreToProductDetailSelection(params) {
  return {
    intro: "$.data.gearDetail.fields[?(@.name === 'productSelectionIntro')].value",
    body: `<p>${params.data.gearDetail.fields.find(x => x.name === "productSelectionBody")?.value}</p>`
  };
}

export function mappingGemsToProductDetailHero(params) {
  return {
    spuId: "$.obj.data.id",
    productName: params.obj.productDescribe || "",

    testFn: item => {
      return item.spuId;
    }
  };
}

export function mappingSitecoreToProductDetailHero() {
  return {
    productHeroImage: {
      src: "$.data.gearDetail.fields[?(@.name === 'productHeroImage')].src",
      alt: "$.data.gearDetail.fields[?(@.name === 'productHeroImage')].alt",
      title: "$.data.gearDetail.fields[?(@.name === 'productHeroImage')].title"
    },
    productDescription: "$.data.gearDetail.fields[?(@.name === 'productDescription')].value"
  };
}

export function mappingGemsToAddToCartBanner(params) {
  return {
    spuId: "$.obj.id",
    name: params.obj.productDescribe,
    testFn: item => {
      return item.spuId;
    }
  };
}

export function mappingSitecoreToProductDetailHeroStore(params) {
  return {
    name: "$.data.brand.fields[?(@.name=== 'name')].value",
    buttonText: "$.data.brand.fields[?(@.name=== 'productHeroStoreCtaText')].value",
    type: "HERO STORE",
    fields: {
      gridType: { fields: { phrase: { value: "normal" } } },
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span>${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "heroStoreHeading")?.value}</span>`
      },
      overlineText: { value: "$.data.brand.fields[?(@.name=== 'name')].value" },
      order: { fields: { phrase: { value: "reverse" } } },
      showRadialGradiant: { value: false },
      image: { value: {} },
      videoAutoPlay: { value: false },
      sound: { value: false },
      backgroundImage: {
        value: {
          src: "$.data.brand.fields[?(@.name === 'heroStoreBackgroundImage')].src",
          alt: "$.data.brand.fields[?(@.name === 'heroStoreBackgroundImage')].alt",
          title: "$.data.brand.fields[?(@.name === 'heroStoreBackgroundImage')].title"
        }
      },
      body: {
        value: `<p>${params.data && params.data.brand && params.data.brand.fields.find(x => x.name === "heroStoreBody")?.value}</p>`
      }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingSitecoreToProductIconContent(params) {
  return {
    type: "ICON CONTENT",
    fields: {
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: params.data.gearDetail && params.data.gearDetail.fields.find(x => x.name === "headingIconContent")?.value && `<span>${params.data.gearDetail && params.data.gearDetail.fields.find(x => x.name === "headingIconContent")?.value}</span> `
      },
      gridType: { fields: { phrase: { value: "normal" } } },
      order: { fields: { phrase: { value: "reverse" } } },

      image: {
        value: {
          src: "$.data.gearDetail.fields[?(@.name === 'imageIconContent')].src",
          alt: "$.data.gearDetail.fields[?(@.name === 'imageIconContent')].alt",
          title: "$.data.gearDetail.fields[?(@.name === 'imageIconContent')].title"
        }
      },
      icons: { value: {} },
      equalColumns: { value: true },
      body: {
        value: `<p>${params.data.gearDetail && params.data.gearDetail.fields.find(x => x.name === "bodyIconContent")?.value}</p> `
      }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingSitecoreToProductHeroMedia(params) {
  return {
    fields: {
      gridType: { fields: { phrase: { value: "normal" } } },
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: params.data.gearDetail && params.data.gearDetail.fields.find(x => x.name === "headingVideo")?.value && `<span>${params.data.gearDetail && params.data.gearDetail.fields.find(x => x.name === "headingVideo")?.value}</span> `
      },
      alignment: {
        fields: { phrase: { value: "center" }, key: { value: "center" } }
      },
      order: { fields: { phrase: { value: "reverse" } } },
      showRadialGradiant: { value: false },
      video: {
        value: {
          src: "$.data.gearDetail.fields[?(@.name === 'video')].url",
          title: "$.data.gearDetail.fields[?(@.name === 'video')].title",
          mimeType: "$.data.gearDetail.fields[?(@.name === 'video')].mimeType",
          size: "$.data.gearDetail.fields[?(@.name === 'video')].size"
        }
      },
      image: {
        value: {
          src: "$.data.gearDetail.fields[?(@.name === 'videoCoverImage')].src",
          alt: "$.data.gearDetail.fields[?(@.name === 'videoCoverImage')].alt",
          title: "$.data.gearDetail.fields[?(@.name === 'videoCoverImage')].title"
        }
      },
      videoAutoPlay: { value: false },
      sound: { value: false }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingSitecoreToProductAccordion() {
  return {
    fields: {
      gridType: { fields: { phrase: { value: "normal" } } },
      headingBody: "$.data.gearDetail.children[?(@.template.name ==='Accordion')].fields[?(@.name=='headingBody')]",
      bodyText: "$.data.gearDetail.children[?(@.template.name ==='Accordion')].fields[?(@.name=='bodyText')]",
      items: [
        "$.data.gearDetail.children[?(@.template.name ==='Accordion')].children.",
        {
          fields: {
            headingType: { fields: { phrase: { value: "span" } } },
            headingBody: {
              value: "$.fields[?(@.name=='headingBody')].value"
            },
            body: { value: "$.fields[?(@.name=='body')].value" },
            collapsed: { value: "$.fields[?(@.name=='collapsed')].value" }
          }
        }
      ]
    },
    rendering: { dataSource: {} }
  };
}

export function mappingGemsProductDetailToCartItem(paramsObj) {
  const { variationInfo, stockInfo } = paramsObj;
  let obj = {};
  if (variationInfo.obj && stockInfo) {
    return (obj = {
      quantity: 1,
      name: stockInfo.obj.spuName,
      price: `${stockInfo.obj ? variationInfo.obj.lowestPrice : stockInfo.obj.price}`,
      image: {
        type: "image",
        src: stockInfo.obj ? stockInfo.obj.skuDefaultImage : variationInfo.obj.spuImagesList[0].path,
        alt: "",
        title: ""
      },
      details: [
        "$.variationInfo.obj.skuAttributeList.",
        {
          title: "$.lable" || "",
          value: "$.spuSkuAttibuteValueList[0].value"
        }
      ],
      availableStock: stockInfo.obj && stockInfo.obj.usableStock ? stockInfo.obj.usableStock : 0
    });
  }

  return obj;
}

export function mappingCartMergeToCartItem(paramsObj) {
  let obj = {
    items: [],
    totalPrice: 0,
    discountPrice: 0,
    afterDiscountTotalPrice: 0
  };
  if (paramsObj.obj) {
    obj = {
      data: "$.obj",
      items: [
        "$.obj.skuList.",

        {
          name: "$.spuName",
          productPage: paramsObj.productPageLink,
          productPath: "/{$.spuId}--{$.scBrandName}--{$.scProductName}",
          price: "$.unitPrice",
          totalPrice: "$.totalActualPrice",
          discountedPrice: "$.unitPriceDiscounted",
          promotionTotal: "$.promotionTotal",
          image: {
            type: "image",
            src: "$.skuImage" || "",
            alt: "",
            title: ""
          },
          quantity: "$.skuCount",
          categories: "$.categories." || [],
          storeName: getStoreName(`$.categories.` || []),
          brand: "$.brandName." || "",
          details: [
            "$.skuAttributes.",
            {
              title: "$.label" || "",
              value: "$.value"
            }
          ],
          skuId: "$.skuId",
          spuId: "$.spuId"
        }
      ],
      totalPrice: paramsObj.obj ? paramsObj.obj.skuOriginalTotalPrice : 0,
      discountPrice: paramsObj.obj ? paramsObj.obj.discountPrice : 0,
      afterDiscountTotalPrice: paramsObj.obj ? paramsObj.obj.afterDiscountTotalPrice : 0
    };
  }

  return obj;
}

export function mappingSitecoreToOtherGear(headingBody) {
  return {
    fields: {
      gridType: { fields: { phrase: { value: "normal" } } },
      paddingAboveBottom: { fields: { phrase: { value: "default" } } },
      paddingAboveTop: { fields: { phrase: { value: "default" } } },
      paginationStyle: { fields: { phrase: { value: "carousel" } } },
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: { value: `<span class='type-h2'>${headingBody || ""}</span>` },
      numberOfItemsInRowMobile: { value: 3 }
    },
    rendering: { dataSource: {} }
  };
}

export function mappingGemsToOtherGear(params, lang) {
  return {
    fields: {
      headingType: { fields: { phrase: { value: "span" } } },
      headingBody: {
        value: `<span>${params.productName}</span>`
      },
      body: {
        value: `<span class="type-h4">${MathUtils.priceFormat(params.minPrice, lang)}</span>`
      },
      image: {
        value: {
          type: "image",
          src: params.images[0],
          alt: "",
          title: ""
        }
      },
      CTA: [
        {
          fields: {
            ctatype: {
              fields: {
                key: { value: "primary-link" },
                phrase: { value: "primary-link" }
              }
            },
            colorScheme: {
              fields: {
                phrase: { value: "green" },
                key: { value: "green" }
              }
            },
            link: {
              value: {
                anchor: "",
                class: "",
                href: "",
                linktype: "internal",
                querystring: "",
                target: "",
                text: "",
                title: ""
              }
            },
            iconName: {
              value: {
                alt: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
              }
            }
          }
        }
      ]
    },
    rendering: { dataSource: {} }
  };
}
export function getStoreName(categories) {
  let storeName = "Global Gear";
  if (Array.isArray(categories) && categories.length > 0) {
    const categoryId = categories.find(x => x.categoryName.toLowerCase() === "location") ? categories.find(x => x.categoryName.toLowerCase() === "location").categoryId : undefined;
    storeName = categoryId ? categories.find(x => x.parentId === categoryId).categoryName : storeName;
  }
  return storeName;
}
export function getBrandName(categories) {
  let brandName = "Global";
  if (Array.isArray(categories) && categories.length > 0) {
    const categoryId = categories.find(x => x.categoryName.toLowerCase() === "brand") ? categories.find(x => x.categoryName.toLowerCase() === "brand").categoryId : undefined;
    brandName = categoryId ? categories.find(x => x.parentId === categoryId).categoryName : brandName;
  }
  return brandName;
}
